
















import Vue from 'vue';

export default Vue.extend({
	name: 'Speakers',
	data: function(){
		return {
			speakers: [
				{ name: "Денис Новак", post: "Заместитель Министра юстиции РФ", img :"novak.jpg" },
				{ name: "Елена Авакян", post: "Член Совета ФПА, советник ФПА РФ, исполнительный директор НП «Содействие развитию корпоративного законодательства», советник Адвокатского бюро «Егоров, Пугинский, Афанасьев и партнеры»", img :"avakjan.jpg" },
				{ name: "Илья Стребулаев", post: "Профессор Стэнфордской высшей школы бизнеса ", img :"strebulaev.jpg" },
				{ name: "Алексей Солохин", post: "Преподаватель факультета повышения квалификации судей Российского государственного университета правосудия, советник Управления публичного права и процесса ВАС РФ (до августа 2014 года), эксперт по гражданскому и арбитражному процессам, исполнительному производству и альтернативным способам разрешения споров", img :".jpg" },
				{ name: "Владимир Ярков", post: "Заведующий кафедрой гражданского процесса УрГЮУ", img :".jpg" },
				{ name: "Алексей Пелевин", post: "CEO PravoTech", img :"pelevin.jpg" },
				{ name: "Татьяна Стукалова", post: "Сопредседатель Коллегии адвокатов «Регионсервис», г. Москва, адвокат, к.ю.н., заместитель Президента Гильдии российских адвокатов", img :"stukalova.jpg" },
				{ name: "Роман Ходыкин", post: "Партнер лондонского офиса фирмы «Bryan Cave Leighton Paisner», солиситор Высших судов Англии и Уэльса, приглашенный профессор университета Королевы Марии (Queen Mary University), Лондон", img :"xodykin.jpg" },
				{ name: "Ольга Болтенко", post: "партнёр китайской юридической компании Fangda Partners (ФангдаПартнерс), Гонконг", img :".jpg" },
				{ name: "Андрей Переладов", post: "Сопредседатель Коллегии адвокатов «Регионсервис», г. Кемерово, адвокат, член Общественной палаты Кемеровской области – председатель комиссии по вопросам безопасности и взаимодействия с правоохранительными органами ", img :"pereladov.jpg" },
				{ name: "Михаил Шварц", post: "К.ю.н., доцент кафедры гражданского процесса юридического факультета Санкт-Петербургского государственного университета, управляющий партнер АБ «Шварц и партнеры» ", img :"shvarc.jpg" },
				{ name: "Александр Ягельницкий", post: "Советник юридической фирмы Petrol Chilikov, доцент кафедры гражданского права МГУ им. М.В. Ломоносова, к.ю.н., магистр юриспруденции (РШЧП)", img :"jagelnickiy.jpg" },
				{ name: "Галина Виленская", post: "Начальник правового управления дирекции по юридическим вопросам ПАО «ГТЛК»", img :".jpg" },
				{ name: "Евгений Акимов", post: "Управляющий директор, начальник управления принудительного взыскания и банкротства департамента по работе с проблемными активами ПАО «Сбербанк»", img :"akimov.jpg" },
				{ name: "Виктор Домшенко", post: "Руководитель отдела судебной защиты АО «Почта России», магистр юриспруденции (РШЧП)", img :".jpg" },
				{ name: "Константин Гричанин", post: "Заместитель директора Департамента судебной практики НК Роснефть", img :".jpg" },
				{ name: "Айс Лиджанова", post: "Старший юрист, адвокат Адвокатского бюро «Егоров, Пугинский, Афанасьев и партнёры»", img :"lidzhanova.jpg" },
				{ name: "Антон Еремеев", post: "Эксперт юридического департамента Банка ВТБ, магистр юриспруденции (РШЧП)", img :".jpg" },
			]
		}
	}
});
